import React from 'react';
import classNames from 'classnames';
import { ReadSurah } from '@/infrastructure/class/read-surah';
import s from './styles.module.scss';
import ReadSurahsListItemMenuBtn from '../../menu-btn/index';
import Link from 'next/link';
import { routes } from '@/infrastructure/const/routes';

interface IReadSurahsListItemProps {
  data: ReadSurah;
  needTopBorder: boolean;
  className?: string;
}

const ReadSurahsListItem: React.FC<IReadSurahsListItemProps> = (props) => {
  const { data, needTopBorder, className = '' } = props;

  const route = `${routes.surahRead}/${data.slug}`;

  const readSurahsListItemClassNames = classNames(s['table-row'], className, {
    [s['border-top']]: needTopBorder,
  });

  return (
    <tr className={readSurahsListItemClassNames}>
      <td>
        <div className={s['index']}>{data.index}</div>
      </td>
      <td className={s['title']}>
        <Link className={s['link']} href={route} prefetch={false} passHref>
          {`${data.titleEn} ${data.transliteration}`}
          <br />
          <span className={s['ar']}>{data.titleAr}</span>
        </Link>
      </td>
      <td>
        <ReadSurahsListItemMenuBtn data={data} />
      </td>
    </tr>
  );
};

export default ReadSurahsListItem;
